import { addYears } from 'date-fns';

export function getYearsAdded(date, years) {
  return addYears(date, years);
}
